<template>
    <div>
      <v-card width="640">
        <StreamBarcodeReader v-if="isMounted" @decode="onDecode" @loaded="onLoaded" width="640"></StreamBarcodeReader>
      </v-card>
      <v-card>
       
    </v-card>
    </div>
  </template>
  <script>
  //import vuetify from "./plugins/vuetify";
  import { StreamBarcodeReader } from "vue-barcode-reader";
  
  
  export default{
    name: 'checkin-member',
    components:{
        StreamBarcodeReader
    },
    props: {
      table: String
    },
    data () {
      return{
          title:'Check-In',
          lists:[],
          isMounted:true,
          select:'',
          distros:[],
          message:'',
          rules: [v => v.length <= 160 || 'Max 160 characters']
      }
     },
     methods:{
        onDecode(text) {
            console.log(`Decode text from QR code is ${text}`);
            this.$emit("CodeRead",text);
        },
        onLoaded() {
            console.log(`Ready to start scanning barcodes`)
        }
     },
    created(){
     
    },
    mounted(){
      console.log("mounted")
      this.isMounted = true;
    },
    unmounted(){
      console.log("unmounted")
      this.isMounted = false;
    },
    destroyed(){
      console.log("destroyed")
      this.isMounted = false;
    }

  }

  </script>
  